import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 22L12 2L22 22H2ZM12.7 10C12.7 9.614 12.386 9.3 12 9.3C11.614 9.3 11.3 9.614 11.3 10V15C11.3 15.386 11.614 15.7 12 15.7C12.386 15.7 12.7 15.386 12.7 15V10ZM12 17.5C11.448 17.5 11 17.948 11 18.5C11 19.052 11.448 19.5 12 19.5C12.552 19.5 13 19.052 13 18.5C13 17.948 12.552 17.5 12 17.5Z",
		fill: "currentColor"
	})
});
export default SvgWarningFill;
